/* eslint-disable i18next/no-literal-string */
import React from 'react';
import Hero from './Hero';
import Why from './Why';
import AIVideography from './AIVideography';
import Features from './Features';
import SignUp from './SignUp';
import styles from './Landing.module.scss';
import Footer from './Footer';
import Betates from './Betates';

export default function Landing() {
  return (
    <div className={styles.container}>
      <Hero />
      <Why />
      <AIVideography />
      <Features />
      <div className={styles.fadeOut} />
      <SignUp />
      <Betates />
      <Footer />
    </div>
  );
}
